import { observable, makeObservable } from 'mobx'
import * as R from 'ramda'

class HomeStore {
    @observable surveys = []

    @observable activeSurveys = []

    @observable developmentSurveys = []

    @observable industries = []

    @observable industryChooseOpen = false

    @observable industryChooseType = ''

    @observable loadSpinner = false

    @observable maxbiEntries = []

    constructor(store) {
        makeObservable(this)
        this.appStore = store
    }

    initSearch = async (maxbiStatus) => {
        this.loadSpinner = true
        if (maxbiStatus.nonMaxbi) {
            await Promise.all([this.getSurveys(), this.getIndustries()])
            // create a field in the active surveys to track surveyid productid and respondentType
            this.activeSurveys = this.surveys.activeSurveys.map((survey) => {
                survey.sIdpIdrType = JSON.stringify({
                    surveyId: survey.surveyId,
                    productId: survey.productId,
                    respondentType: survey.respondentType,
                    surveyTypeName: survey.surveyTypeName,
                })

                return survey
            })

            this.developmentSurveys = this.surveys.developmentSurveys.map((survey) => {
                survey.sIdpIdrType = JSON.stringify({
                    surveyId: survey.surveyId,
                    productId: survey.productId,
                    respondentType: survey.respondentType,
                    surveyTypeName: survey.surveyType,
                })

                return survey
            })
        }
        if (maxbiStatus.maxbi) {
            await this.getMaxbiEntries()
        }
        this.loadSpinner = false
    }

    getSurveys = async () => {
        this.surveys = await this.appStore.http.get('/home/surveys') // Surveys
    }

    getIndustries = async () => {
        this.industries = await this.appStore.http.get('/client/industry') // industries
    }

    toggleIndustryChoose = (type) => {
        const { industries } = this
        this.industryChooseType = type
        const industryChooseOpen = !this.industryChooseOpen
        if (industryChooseOpen) {
            if (industries.length === 1) {
                this.openCreateItem(industries[0].code)
                return
            }
        }
        this.industryChooseOpen = industryChooseOpen
    }

    openCreateItem = (industryCode) => {
        const { industryChooseType } = this
        switch (industryChooseType) {
            case 'product':
                window.location = `/event/0/${industryCode}`
                break
            case 'survey':
                window.location = `/survey/0/${industryCode}`
                break
            default:
        }
    }

    openCreateMaxbi = () => {
        window.location = '/survey/0/CE?surveytype=EM'
    }

    getMaxbiEntries = async () => {
        const surveys = await this.appStore.http.get('/maxbi?limit=5&active=1')
        this.maxbiEntries = R.sortWith([
            R.descend(R.prop('closeDate')),
        ])(surveys)
    }
}

export default HomeStore
